import { render } from "./ClientProjectDetail.vue?vue&type=template&id=3c214a22&scoped=true"
import script from "./ClientProjectDetail.vue?vue&type=script&lang=js"
export * from "./ClientProjectDetail.vue?vue&type=script&lang=js"

import "./ClientProjectDetail.vue?vue&type=style&index=0&id=3c214a22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c214a22"]])

export default __exports__